module.exports = __webpack_public_path__ + "static/media/CHANGELOG.240987d3.md";